import lodashGet from "lodash/get";
import React, { ComponentPropsWithoutRef } from "react";

import { PillarTableBaseColumnProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { renderTemplateUtil } from "shared/components/template/renderTemplateUtil";
import { sanitizeHtml } from "shared/components/template/sanitize-html";

export type PillarTableColumnTemplateProps<T> = {
  template?: string;
  cellValuePath?: string;
} & PillarTableBaseColumnProps<T> &
  ComponentPropsWithoutRef<"div">;

const PillarTableColumnTemplate = <T,>({
  cellValuePath,
  template = "",
}: PillarTableColumnTemplateProps<T>) => {
  const rowContext = usePillarTableRowContext();

  if (cellValuePath) {
    template = lodashGet(rowContext?.rowValue, cellValuePath) || "";
  }

  return (
    <>
      <span
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(
            renderTemplateUtil({
              template,
              templateData: rowContext?.rowValue || {},
            }),
          ),
        }}
      />
    </>
  );
};

export default PillarTableColumnTemplate;
